var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/arrowdown2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4257 7.49829H5.57237C4.69237 7.49829 4.25237 8.56162 4.8757 9.18496L9.62404 13.9333C10.3849 14.6941 11.6224 14.6941 12.3832 13.9333L14.189 12.1275L17.1315 9.18496C17.7457 8.56162 17.3057 7.49829 16.4257 7.49829Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown2);
export default __webpack_public_path__ + "static/media/arrowdown2.ac2fa09800511e3199844c73a7f5beae.svg";
export { ForwardRef as ReactComponent };